var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({attrs:{"is-loading":_vm.isLoading}},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('a',{attrs:{"target":"_blank","href":_vm.clickUrl}},[_c('img',{staticClass:"center full-width",attrs:{"src":_vm.url}})]),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c187a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImagePost/ImagePost.vue
// module id = Iava
// module chunks = 1